import { Component, ChangeDetectionStrategy } from '@angular/core';
import { User } from '../../interfaces/user';
import { Router } from '@angular/router';
import { StateService } from '../../services/state.service';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UserRoleGroups } from '../../enum/user-role-types';

@Component({
    selector: 'app-sidebar',
    imports: [NgClass, NgbTooltipModule],
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  user = {} as User;
  subRoute: Subscription;
  currentRoute: string = '';
  readonly UserRoleGroups = UserRoleGroups;
  constructor(
    private router : Router,
    private state: StateService
  ){
    this.user = JSON.parse(sessionStorage.getItem('user')??'{}');
    this.subRoute = new Subscription();
  }

  navTo(path: string){
    this.router.navigate([path]);
  }

  ngOnInit():void{
    this.subRoute = this.state.currentRoute.subscribe(route => {
      this.currentRoute = route; 
    });
  }

  ngOnDestroy():void{
    this.subRoute.unsubscribe();
  }
}
